import {css} from 'glamor'
import Image from 'react-bootstrap/lib/Image'
import Modal from 'react-bootstrap/lib/Modal'
import PropTypes from 'prop-types'
import React from 'react'
import {changeHost} from '../shared/utils'

const style = {
  header: css({
    borderBottom: 'none',
    height: 0,
    padding: 0,
    '> .close': {
      fontSize: '50px',
      margin: '0 12px -40px 0',
      position: 'relative',
      zIndex: 1
    }
  })
}

const LargeImgModal = ({
  children,
  imageHost,
  imgSrc,
  onClose,
  show,
  newImageServer = false
}) => {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton {...style.header} />
      <Modal.Body>
        {newImageServer && <Image responsive src={imgSrc} />}
        {!newImageServer && imgSrc ? (
          <Image responsive src={changeHost(imgSrc, imageHost)} />
        ) : (
          children
        )}
      </Modal.Body>
    </Modal>
  )
}

LargeImgModal.propTypes = {
  children: PropTypes.node,
  imageHost: PropTypes.string,
  imgSrc: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  newImageServer: PropTypes.string
}

export default LargeImgModal
